import "./RegistrationError.css";
import React from "react";
import autobind from "autobind-decorator";
import PropulatedView from "higher-order/PropulatedView";
import PropsStore from "gradifui/models/PropsStore";
import SessionPageContent from "../components/SessionPageContent";
import ContentItem, { ContentItemUtilities } from "shared/components/cms/ContentItem";
import { URLS } from "util/constants";

// Hardcoded headers in RegistrationViewModelBuilder.cs
const INVITATION_PREVIOUSLY_CLAIMED = "invitationPreviouslyClaimedSubheader";
const INVITATION_NOT_FOUND_SUBHEADER = "invitationNotFoundSubheader";

class RegistrationError extends React.Component {
    @autobind
    getSubheaderStringFormatArgs(subHeaderMessageErrorKey) {
        switch (subHeaderMessageErrorKey) {
            case INVITATION_NOT_FOUND_SUBHEADER:
                return {
                    contactLink: ContentItemUtilities.stringifyComponent(
                        <a title="Contact Gradifi" href={URLS.MARKETING.CONTACT}>contact Gradifi support</a>
                    )
                };
            case INVITATION_PREVIOUSLY_CLAIMED:
                return {
                    loginLink: ContentItemUtilities.stringifyComponent(
                        <a title="Gradifi Login" href={this.props.loginPath}>login</a>
                    ),
                    resendLink: ContentItemUtilities.stringifyComponent(
                        <a title="Re-send invitation" href={URLS.RESEND_INVITATION}>re-sent</a>
                    )
                };
            default:
                return null;
        }
    }

    render() {
        const headerMessageErrorKey = this.props.errorMessageKey + "Header";
        const subHeaderMessageErrorKey = this.props.errorMessageKey + "Subheader";
        const phoneStringFormatArgs = {
            phoneLink: ContentItemUtilities.stringifyComponent(
                <a href={"tel:+" + this.props.memberSupportNumber}>
                    (844) GRADIFI (472-3434)
                </a>
            )
        };
        const emailStringFormatArgs = {
            emailLink: ContentItemUtilities.stringifyComponent(
                <a href={"mailto:" + this.props.memberSupportEmail + "?subject=Gradifi%20member%20support%20question"}>
                    {this.props.memberSupportEmail}
                </a>
            )
        };
        return (
            <SessionPageContent>
                <ContentItem contentKey={headerMessageErrorKey} tag="h1" />
                <ContentItem
                    contentKey={subHeaderMessageErrorKey}
                    stringFormatArgs={this.getSubheaderStringFormatArgs(subHeaderMessageErrorKey)}
                    tag="section"
                />
                <div className="support-section">
                    <ContentItem
                        contentKey="memberSupport"
                        className="member-support-header"
                        tag="h3"
                    />
                    <div className="member-support-contact">
                        <ContentItem
                            contentKey="memberSupportPhone"
                            className="member-support-phone"
                            stringFormatArgs={phoneStringFormatArgs}
                            tag="span"
                        />
                        <span className="divider">|</span>
                        <ContentItem
                            contentKey="memberSupportEmail"
                            className="member-support-email"
                            stringFormatArgs={emailStringFormatArgs}
                            tag="span"
                        />
                    </div>
                    <ContentItem contentKey="supportHours" className="member-support-hours" tag="p" />
                    <a href={this.props.loginPath}>
                        <ContentItem contentKey="backToLogin" className="back-to-login-link" />
                    </a>
                </div>
            </SessionPageContent>
        );
    }
}

export default PropulatedView(RegistrationError, PropsStore, ["errorMessageKey", "memberSupportNumber", "memberSupportEmail", "loginPath"]);
